import { IFranchiseResponseDTO } from 'main/modules/admin/services/franchise/dtos/response/IFranchiseReponseDTO'
import { FranchiseFormModel } from 'main/modules/admin/components/franchise-data-screen-content/inner/FranchiseFormModel'
import { IFranchiseSaveRequestDTO } from 'main/modules/admin/services/franchise/dtos/request/IFranchiseSaveRequestDTO'
import { MaskUtils } from 'main/common/utils/MaskUtils'

/**
 * UTILTARIOS
 * Reune metodos uteis para manipular formulario de dados da franquia.
 */
export const FranchiseFormUtils = {

    /**
     * Gera FormModel de Franquia a partir do DTO
     */
    getFormData(dto: IFranchiseResponseDTO): Partial<FranchiseFormModel> {
        return {
            cnpj: dto.cnpj,
            socialName: dto.socialName,
            fantasyName: dto.fantasyName,
            email: dto.email,
            phone: dto.phone,
            stateRegistration: dto.stateRegistration,
            zipCode: dto.address?.zipCode,
            street: dto.address?.street,
            number: dto.address?.number,
            complement: dto.address?.complement,
            neighborhood: dto.address?.neighborhood,
            city: dto.address?.city,
            state: dto.address?.state
        }
    },

    /**
     * Gera DTO de Franquia a partir do FormModel
     */
    getDto(formModel: FranchiseFormModel): IFranchiseSaveRequestDTO {
        return {
            cnpj: formModel.cnpj,
            socialName: formModel.socialName,
            fantasyName: formModel.fantasyName,
            email: formModel.email,
            phone: MaskUtils.removeMask(formModel.phone),
            stateRegistration: formModel.stateRegistration,
            ocultarProcedimentos:formModel.ocultarProcedimentos,
            address: {
                street: formModel.street,
                neighborhood: formModel.neighborhood,
                complement: formModel.complement,
                number: formModel.number ? formModel.number.toString() : undefined,
                zipCode: formModel.zipCode,
                city: formModel.city,
                state: formModel.state,
            }
        }
    },
}
